<template>
    <div>
        <div>
            <h3>File Search</h3>
        </div>
        <div class="wrapper">
            <div class="row row-wider">
                <div class="col-md-12" style="min-height: 150px;">
                    <div class="alert alert-warning" role="warning" v-if="fileSearchLoading && paymentLoading"
                        style="margin-bottom: 20px;">
                        <div style="margin-bottom: 10px;">Please wait while we process your File Search for payment.
                            This may take a few minutes. Please do not close this window or click the back button.
                        </div>
                        <div v-if="trsProcessing" class="my-3" style="clear: both;">
                            <div class="mb-1" style="font-weight: bold; color: #364760">{{ trsProcessText }}</div>
                            <div>

                                <div class="progress">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar" :style="{ width: trsProcessPercent + '%' }"
                                        :aria-valuenow="trsProcessPercent" aria-valuemin="0" aria-valuemax="100">
                                        {{ trsProcessPercent }}%
                                    </div>
                                </div>
                                <img src="../img/loading-black.gif" />
                            </div>


                        </div>
                    </div>
                    <loader v-if="fileSearchLoading && !trsProcessing"></loader>
                    <div v-if="!fileSearchLoading">
                        <tabs nav-style="tabs" v-model="activeTabIndex">
                            <tab header="File Search">
                                <projectHeader v-bind:project="project"></projectHeader>
                                <div style="margin-top: 20px;">
                                    <div>
                                        <media :mediaTypeId="mediaTypeId" :parentId="fileSearchId"
                                            :formDisabled="formDisabled"
                                            v-on:mediaRefreshComplete="handleMediaRefreshComplete()"
                                            v-on:mediaRefreshStarted="handleMediaRefreshStarted()" ref="media"></media>
                                    </div>
                                </div>
                                <div style="clear: both;">
                                    <hr />
                                </div>
                                <div class="form-horizontal" v-if="!formDisabled">
                                    <plssComponent v-on:savePlss="savePlssFileSearch" ref="plssComponent">
                                    </plssComponent>
                                </div>
                                <div v-if="hasFieldworkRequest && !formDisabled">
                                    <button class="btn btn-primary" v-on:click="copyFwrPlss()">Copy Fieldwork Request
                                        PLSS Locations</button>
                                </div>
                                <div v-if="hasE106Compliance && !formDisabled">
                                    <button class="btn btn-primary" v-on:click="copyE106Plss()">Copy E106 Compliance
                                        PLSS Locations</button>
                                </div>
                                <div v-show="plssLocationGridSpec.tableData.length > 0">
                                    <h4>Section List</h4>
                                    <v-client-table :data="plssLocationGridSpec.tableData"
                                        :columns="plssLocationGridSpec.columns" :options="plssLocationGridSpec.options">
                                        <template slot="delete" slot-scope="props">
                                            <div style="text-align: center;" v-if="!formDisabled">
                                                <a class="fa fa-ban" style="font-size: 18px;"
                                                    v-on:click="deletePlssLocation(props.row.fileSearchPlssLocationId)"></a>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                                <div v-if="canPlaceOrder">
                                    <h4>Submission</h4>
                                    <div class="form-group">
                                        <div class="col-md-3">
                                        </div>
                                        <div class="col-md-2">
                                            <button :disabled="mediaRefreshing" name="button2"
                                                class="btn btn-primary btn-block" type="submit" v-on:click="goPayment"
                                                style="width:120px;">Place Order</button>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!canPlaceOrder">
                                    <div class="form-group">
                                        <div class="alert alert-warning" role="warning" v-if="containsWindRiver">
                                            <i class="fa fa-warning">&nbsp;</i><strong>Please Note:</strong> This file
                                            search requests data from the Wind River meridian. <strong>The request will
                                                need to be reviewed by SHPO.</strong>
                                        </div>
                                        <div class="alert alert-warning" role="warning" v-if="isLargeFileSearches">
                                            <i class="fa fa-warning">&nbsp;</i><strong>Please Note:</strong> This file
                                            search contains over {{largeFsCutOff}} sections. <strong>The request will
                                                need to be reviewed by SHPO.</strong>
                                        </div>
                                    </div>
                                </div>

                            </tab>
                            <tab header="Files">
                                <projectHeader v-bind:project="project"></projectHeader>
                                <div style="margin-top: 20px;" id="files">
                                    <mediaLetter :mediaTypeId="mediaTypeIdFsLetter" :parentId="fileSearchId">
                                    </mediaLetter>
                                </div>
                                <div style="margin-top: 20px;">
                                    <mediaFileSearchReport :parentId="fileSearchId"
                                        :fileSearchComplete="fileSearchComplete" ref="mediaFileSearchReport">
                                    </mediaFileSearchReport>
                                </div>
                                <div v-if="fileSearchComplete" style="margin-top: 20px;">
                                    <h4>File Search Sites</h4>
                                    <div>
                                        <v-client-table :data="crGridSpec.tableData" :columns="crGridSpec.columns"
                                            :options="crGridSpec.options">
                                            <template slot="select" slot-scope="props">
                                                <div style="text-align: center">
                                                    <router-link
                                                        :to="{ path: '/CulturalResource/' + props.row.culturalResourceId }"
                                                        v-if="props.row.culturalResourceId" tag="a" class="fa fa-edit"
                                                        style="font-size: 16px;"></router-link>
                                                </div>
                                            </template>
                                        </v-client-table>
                                    </div>
                                    <div v-if="this.crGridSpec.tableDataTcp.length > 0" style="margin-top:20px;">
                                        <h4 style="color: red;">Tribal Cultural Properties</h4>
                                        <div>
                                            <v-client-table :data="crGridSpec.tableDataTcp"
                                                :columns="crGridSpec.columns" :options="crGridSpec.options">
                                                <template slot="select" slot-scope="props">
                                                    <div style="text-align: center">
                                                        <router-link
                                                            :to="{ path: '/CulturalResource/' + props.row.culturalResourceId }"
                                                            v-if="props.row.culturalResourceId" tag="a"
                                                            class="fa fa-edit" style="font-size: 16px;"></router-link>
                                                    </div>
                                                </template>
                                            </v-client-table>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="canGetZip && zipFileAlertHidden && !restrictedOrganizationRole">
                                    <button class="btn btn-primary" v-on:click="getSiteZip">Get Shapefiles</button>
                                </div>
                                <div style="margin-top: 10px; width: 99%;">
                                    <div class="alert alert-success alert-dismissible"
                                        v-bind:class="{ 'hidden' : zipFileAlertHidden }" role="alert">
                                        <!-- <button type="button" class="close" v-on:click="zipFileAlertHidden = true">
                                            <span aria-hidden="true">&times;</span>
                                        </button> -->
                                        Zip file is being generated. It will be downloaded to your browser's Downloads
                                        folder in a few moments.
                                    </div>
                                </div>
                            </tab>
                            <tab header="Map">
                                <projectHeader :project="project" />
                                <mapx :mediaTypeId="mediaTypeId" :parentId="fileSearchId" :loadOnMount="false"
                                    ref="mapx"></mapx>
                            </tab>
                            <tab header="Workflow">
                                <projectHeader v-bind:project="project"></projectHeader>
                                <div style="margin-top: 20px;">
                                    <workflow :workflowId="fileSearchWorkflowId" :parentId="fileSearchId" ref="workflow"
                                        v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
                                </div>
                                <button v-if="paymentReceipt" name="button3" class="btn btn-primary btn-block"
                                    type="submit" v-on:click="goPaymentReceipt" style="width:150px;">Payment
                                    Receipt</button>
                                <div v-if="checkShpoRole" style="margin-top: 20px;">
                                    <quickLetter :projectId="project.projectId" :fileSearchId="fileSearch.fileSearchId"
                                        :mediaTypeId="mediaTypeIdFsLetter" :parentId="fileSearchId"></quickLetter>
                                </div>
                            </tab>
                        </tabs>
                    </div>

                    <div v-show="isDebug" style="margin-top: 20px;">
                        <div>
                            <h3 class="text-danger">****** Debug ******</h3>
                        </div>
                        <div>
                            <h4>Validation errors: </h4>
                            <pre>{{ errors }}</pre>
                        </div>

                        <div>
                            <h4>fileSearch: </h4>
                            <pre>{{ fileSearch }}</pre>
                        </div>
                        <div>
                            <h4>PlaceOrder: </h4>
                            <pre>canPlaceOrder: {{ canPlaceOrder }}</pre>
                            <pre>sectionCount: {{ sectionCount }}</pre>
                            <pre>containsWindRiver {{ containsWindRiver }}</pre>
                            <pre>status {{ this.currentWorkflowStatus.workflowStatusDescription }}</pre>
                            <pre>is approved {{ (this.currentWorkflowStatus.workflowStatusDescription === 'Approved') ? 'Yes':'No'}}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import fileSearchService from '../services/fileSearchService'
import meridianService from '../services/lookup/meridianService'
import mediaService from '../services/mediaService'
import projectService from '../services/projectService'
import workflowService from '../services/workflowService'
import paymentService from '../services/paymentService'
import roleService from '../services/roleService.js'
import userService from '@/services/userService.js'
import organizationService from '@/services/organizationService.js'
import culturalResourceService from '@/services/culturalResourceService.js'
import { mapState } from 'vuex'
import gisZipService from '../services/gisZipService.js'
import gisService from '@/services/gisService'
import moment from 'moment'

import workflow from '../components/Workflow.vue'
import loader from '../components/Loader.vue'
import { tab, tabs } from 'vue-strap'
import plssComponent from '../components/PlssComponent'
import projectHeader from '../components/ProjectHeader'
import media from '../components/Media.vue'
import mediaLetter from '../components/MediaLetter.vue'
import quickLetter from '../components/QuickLetter.vue'
import mediaFileSearchReport from '../components/MediaFileSearchReport.vue'
import mapx from '@/views/MapNew'

export default {
    components: {
        tabs,
        tab,
        loader,
        plssComponent,
        projectHeader,
        workflow,
        media,
        mediaLetter,
        quickLetter,
        mediaFileSearchReport,
        mapx
    },
    created () {
        loggingService.log(this.isDebug, 'FileSearch', 'created ')
    },
    mounted () {
        loggingService.log(this.isDebug, 'FileSearch', 'mounted ')

        this.fileSearchLoading = true
        if (this.fileSearchId) {
            //Get the file search, load everything.
            this.loadData()
        } else {
            // The file search does not currently exist, create it then load the rest of the data
            this.fileSearch.projectId = this.$route.query.projectId
            if (!this.fileSearch.projectId) {
                this.$router.push('/FileSearches')
            } else {
                fileSearchService.put(this.$http, this.fileSearch).then(response => {
                    // re-direct to correct route with fileSearchId
                    if (response.data && response.data.isValid && response.data.objectList[0] && response.data.objectList[0].fileSearchId) {
                        this.$router.push('/FileSearch/' + response.data.objectList[0].fileSearchId)
                        this.fileSearch = response.data.objectList[0]
                        Promise.all([this.loadMeridianList(),
                            this.loadPlssLocation(this.fileSearch.fileSearchId),
                            this.loadWorkflowStatus(this.fileSearch.fileSearchId),
                            this.loadProject(this.fileSearch.projectId),
                            this.findRelatedFwrE106(this.fileSearch.fileSearchId)
                        ]).then(results => {
                            this.fileSearchLoading = false
                        })
                    } else {
                        this.$router.push('/FileSearches')
                    }
                })
            }
        }
    },
    data: function () {
        return {
            isDebug: false,
            activeTabIndex: 0,
            fileSearchLoading: false,
            plssTabLoaded: false,
            meridianList: [],
            restrictedOrganizationList: [],
            fileSearch: {},
            sectionCharge: 30.00,
            project: {},
            plssLocationGridSpec: {
                columns: ['meridianDescription', 'locationDescription', 'section', 'delete'],
                tableData: [],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        meridianDescription: 'Meridian',
                        locationDescription: 'Township',
                        section: 'Section',
                        delete: 'Delete'
                    }
                }
            },
            currentWorkflowStatus: {},
            paymentReceipt: null,
            hasFieldworkRequest: false,
            hasE106Compliance: false,
            mediaRefreshing: true,
            zipFileAlertHidden: true,
            crGridSpec: {
                columns: ['select', 'siteName', 'smithsonianNumber', 'currentEligibilityDescription'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        select: 'Select',
                        siteName: 'Site Name',
                        smithsonianNumber: 'Smithsonian Number',
                        currentEligibilityDescription: 'Eligibility'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'smithsonianNumber'
                    }
                },
                tableData: [],
                tableDataTcp: []
            },
            largeFsCutOff: 100,
            tribalConsultationEnum: culturalResourceService.TribalConsultationEnum,
            paymentLoading: false,
            trsProcessText: '',
            trsProcessPercent: 0,
            trsProcessing: false
        }
    },
    computed: {
        fileSearchId: function () {
            return this.$route.params.fileSearchId
        },
        mediaTypeId: function () {
            return mediaService.mediaType.FileSearch
        },
        mediaTypeIdFsLetter: function () {
            return mediaService.mediaType.FileSearchLetter
        },
        fileSearchWorkflowId: function () {
            return workflowService.WorkflowEnum.FileSearch
        },
        sectionCount: function () {
            var count = 0
            if (this.plssLocationGridSpec && this.plssLocationGridSpec.tableData) {
                count = this.plssLocationGridSpec.tableData.length
            }
            return count
        },
        containsWindRiver: function () {
            loggingService.log(this.isDebug, 'FileSearch', 'checking wind river meridian')
            var idx = -1
            if (this.plssLocationGridSpec && this.plssLocationGridSpec.tableData) {
                idx = this.plssLocationGridSpec.tableData.findIndex(location => {
                    loggingService.log(this.isDebug, 'FileSearch', `Meridian check: ++${location.meridianDescription}++`)
                    loggingService.log(this.isDebug, 'FileSearch', 'Matches: ' + ((location.meridianDescription === 'Wind River Meridian') ? 'yes' : 'no'))
                    return location.meridianDescription === 'Wind River Meridian'
                })
                loggingService.log(this.isDebug, 'FileSearch', `idx: ${idx}`)
            }
            loggingService.log(this.isDebug, 'FileSearch', `idx: ${idx}`)
            return idx > -1
        },
        isLargeFileSearches: function () {
            return this.plssLocationGridSpec.tableData.length > this.largeFsCutOff
        },
        pendingDataEntry: function () {
            loggingService.log(this.isDebug, 'FileSearch', 'canPlaceOrder' + this.currentWorkflowStatus.workflowStatusDescription)
            var isNew = !(this.fileSearch.fileSearchId)
            return (isNew || (this.currentWorkflowStatus && this.currentWorkflowStatus.workflowStatusDescription === 'Pending Data Entry'))
        },
        canPlaceOrder: function () {
            loggingService.log(this.isDebug, 'FileSearch', '********************Checking PLACE ORDER******************** ')
            // if (this.mediaRefreshing) {
            //     return false
            // }
            if (this.isShpoReadOnly) return false

            if (this.sectionCount === 0) {
                loggingService.log(this.isDebug, 'FileSearch', 'No sections')
                return false
            }
            if (this.currentWorkflowStatus.workflowStatusDescription === 'Pending Data Entry' && !this.containsWindRiver && !this.isLargeFileSearches) {
                loggingService.log(this.isDebug, 'FileSearch', 'Pending Data Entry, no wind river')
                return true
            }
            if (this.currentWorkflowStatus.workflowStatusDescription === 'Approved') {
                loggingService.log(this.isDebug, 'FileSearch', 'Approved')
                return true
            } else {

            }
            loggingService.log(this.isDebug, 'FileSearch', 'Default return false')
            return false
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        checkShpoRole: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        restrictedOrganizationRole: function () {
            var isRestricted = false
            if (this.shpoUserDto) {
                this.shpoUserDto.userOrganizationList.forEach(org1 => {
                    if (this.restrictedOrganizationList.includes(org1.organizationId)) {
                        isRestricted = true
                    }
                })
            }
            return isRestricted
        },
        canGetZip: function () {
            var today = moment(new Date())
            var oDate = moment(this.currentWorkflowStatus.createdDate || new Date('01/01/1900'))
            var diffDays = oDate.diff(today, 'days')
            return this.fileSearchComplete &&
                diffDays <= 60
        },
        fileSearchComplete: function () {
            return this.currentWorkflowStatus.workflowStatusId === workflowService.FileSearchStatusEnum.PaymentApproved ||
                this.currentWorkflowStatus.workflowStatusId === workflowService.FileSearchStatusEnum.PaymentApprovedTcp
        },
        formDisabled: function () {
            return !this.pendingDataEntry || this.isShpoReadOnly
        }
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'FileSearch', 'watch.activeTabIndex: ' + val)

            switch (val) {
            case 0: //File Search
                loggingService.log(this.isDebug, 'FileSearch', 'watch.activeTabIndex: ' + val + ' - media_update emitted')
                this.$refs.media.$emit('media_update')
                break
            case 1: //Letters
                this.$refs.mediaFileSearchReport.loadMedia()
                break
            case 2: //Map
                this.$refs.mapx.createMap()
                break
            case 3: //Workflow
                loggingService.log(this.isDebug, 'FileSearch', 'watch.activeTabIndex: ' + val + ' - workflow.loadData()')
                this.$refs.workflow.loadData()
                break
            }
        },
        projectId: function (val) {
            loggingService.log(this.isDebug, 'FileSearch', 'watch.projectId: ' + val)
        }
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'FileSearch', 'loadFileSearch - start - fileSearchId: ' + this.fileSearchId)
            fileSearchService.get(this.$http, this.fileSearchId).then(response => {
                loggingService.log(this.isDebug, 'FileSearch', 'loadFileSearch, complete: ' + this.fileSearchId)
                this.fileSearch = response.data
                Promise.all([this.loadMeridianList(),
                    this.loadPlssLocation(this.fileSearchId),
                    this.loadWorkflowStatus(this.fileSearchId),
                    this.loadPaymentReceipt(this.fileSearchId),
                    this.findRelatedFwrE106(this.fileSearchId),
                    this.loadRestrictedOrganizationList()
                ]).then(results => {
                    this.loadProject(this.fileSearch.projectId).then(response => {
                        //load fs cr
                        if (this.fileSearchComplete) {
                            this.loadFileSearchCr(this.fileSearchId)
                        }
                        this.fileSearchLoading = false
                        if (this.$route.hash === '#files') {
                            this.activeTabIndex = 1
                        }
                    })
                })
            }).catch(error => {
                loggingService.log(this.isDebug, 'FileSearch', 'loadFileSearch, error: ' + error.response)
                this.$router.push('/FileSearches')
                return error
            })
        },
        loadFileSearch (fileSearchId) {
            loggingService.log(this.isDebug, 'FileSearch', 'loadFileSearch - start - fileSearchId: ' + fileSearchId)
            return fileSearchService.get(this.$http, fileSearchId).then(response => {
                loggingService.log(this.isDebug, 'FileSearch', 'loadFileSearch, complete: ' + fileSearchId)
                this.fileSearch = response.data
                return response
            }).err(error => {
                this.log(error.response)
                this.$router.push('/FileSearches')
                return error
            })
        },
        loadProject (projectId) {
            loggingService.log(this.isDebug, 'FileSearch', 'loadProject - start - projectId: ' + projectId)
            var handle = this
            return projectService.search(handle.$http, { projectId: handle.fileSearch.projectId }).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadProject - complete')

                handle.project = response.data.length > 0 ? response.data[0] : []
            })
        },
        loadWorkflowStatus (fileSearchId) {
            loggingService.log(this.isDebug, 'FileSearch', 'loadWorkflowStatus for fileSearchID: ' + fileSearchId)
            var handle = this
            return workflowService.currentWorkflowStatusDto(this.$http, this.fileSearchWorkflowId, fileSearchId).then(function (response) {
                handle.currentWorkflowStatus = response.data
                return response
            })
        },
        loadPlssLocation (fileSearchId) {
            loggingService.log(this.isDebug, 'FileSearch', 'loadPlssLocation for ' + fileSearchId)
            var handle = this
            return fileSearchService.plssLocationList(handle.$http, fileSearchId)
                .then(function (response) {
                    handle.plssLocationGridSpec.tableData = response.data
                    return response
                })
        },
        loadMeridianList () {
            loggingService.log(this.isDebug, 'FileSearch', 'loadMeridianList - start')
            var handle = this
            return meridianService.listLookup(handle.$http).then(function (response) {
                loggingService.log(handle.isDebug, 'FileSearch', 'loadMeridianList - complete')
                handle.meridianList = response.data
                return response
            })
        },
        loadRestrictedOrganizationList () {
            loggingService.log(this.isDebug, 'FileSearch', 'loadRestrictedOrganizationList')
            var handle = this
            return organizationService.listShapeFileRestrictedOrgs(handle.$http).then(function (response) {
                handle.restrictedOrganizationList = response.data.map(org => org.organizationId)
                return response
            })
        },
        loadFileSearchCr (fileSearchId) {
            return fileSearchService.listCulturalResourceResults(this.$http, fileSearchId).then(response => {
                let tcpEnum = this.tribalConsultationEnum.TraditionalCulturalProperty
                this.crGridSpec.tableData = response.data
                this.crGridSpec.tableDataTcp = response.data.filter(x => x.isConfidential && x.tribalConsultationId === tcpEnum)

                return response
            })
        },
        savePlssFileSearch () {
            loggingService.log(this.isDebug, 'FileSearch', 'savePlss on fileSearch ' + this.fileSearch.fileSearchId)
            var plss = this.$refs['plssComponent'].plssData
            var handle = this
            fileSearchService.put(handle.$http, this.fileSearch)
            .then(response => {
                loggingService.log(this.isDebug, 'FileSearch.put.then')
                handle.fileSearch = response.data.objectList[0]
                fileSearchService.putPlss(this.$http, handle.fileSearch.fileSearchId, plss)
                .then(response2 => {
                    loggingService.log(this.isDebug, 'FileSearch', 'reloading after Save')
                    this.loadPlssLocation(this.fileSearch.fileSearchId)
                }).then(response3 => {
                    loggingService.log(this.isDebug, 'FileSearch', 'reloading workflow after Save')
                    this.loadWorkflowStatus(this.fileSearch.fileSearchId)
                    this.$refs.workflow.$emit('workflow_update')
                })
            })
        },
        deletePlssLocation (fileSearchPlssLocationId) {
            loggingService.log(this.isDebug, 'FileSearch', 'delete plss Location :' + fileSearchPlssLocationId)
            fileSearchService.deletePlssLocation(this.$http, fileSearchPlssLocationId).then(response => {
                this.loadPlssLocation(this.fileSearch.fileSearchId)
            })
        },
        async goPayment () {
            this.fileSearchLoading = true
            this.paymentLoading = true
            //search cultural resource with PLSS and send to server to validate
            //use gisService to get site results
            var trsDtoList = this.plssLocationGridSpec.tableData.map(x => {
                return {
                    Township: x.township,
                    TownshipDirection: x.townshipDirection,
                    Range: x.range,
                    RangeDirection: x.rangeDirection,
                    Sections: [x.section]
                }
            })
            gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
            // let sitePromises = []
            // let siteResults = []
            // let invPromises = []
            // let invResults = []
            // let trsFeatureResults = []
            // //compile the TRS feature results
            // trsDtoList.forEach(trs => {
            //     gisService.trsQuerySection(trs).then(result => trsFeatureResults.push(result))
            // })

            // trsFeatureResults.forEach(feature => {
            //     sitePromises.push(gisService.trsSiteQueryOnLayerQueryComplete(feature))
            //     invPromises.push(gisService.trsInvQueryOnLayerQueryComplete(feature))
            // })

            // const [resultSites, resultInvs] = await Promise.all([Promise.all(sitePromises), Promise.all(invPromises)])

            // let flatResults = [].concat.apply([], resultSites)
            // flatResults.forEach(result => {
            //     siteResults.push(
            //         {
            //             countyCode: result.attributes.County,
            //             siteNumber: result.attributes.SiteNo,
            //             segment: result.attributes.SegmentId
            //         }
            //     )
            // })
            // let invFlatResults = [].concat.apply([], resultInvs)
            // invFlatResults.forEach(result => {
            //     if (result.attributes && result.attributes.DBI) {
            //         invResults.push(
            //             {
            //                 dbNumber: result.attributes.DBI
            //             }
            //         )
            //     }
            // })
            this.trsProcessing = true
            this.trsProcessText = 'Starting...'
            this.trsProcessPercent = 0
            const { siteResults, invResults } = await gisService.processTrsDtoList(trsDtoList, 25, (current, total) => {
                //this.trsProcessText = `Processing TRS: batch ${current} of ${total}...`
                this.trsProcessText = 'Processing TRS...'
                this.trsProcessPercent = Math.min(Math.round((current / total) * 100), 95)
            })

            this.trsProcessText = 'Updating File Search (this may take a few moments)...'
            fileSearchService.updateFileSearchCrInv(this.$http, this.fileSearchId, siteResults, invResults).then(() => {
                this.$router.push('/FileSearchPayment/' + this.fileSearch.fileSearchId)
            })
        },
        goPaymentReceipt () {
            this.$router.push('/FileSearchPaymentReceipt/' + this.fileSearch.fileSearchId)
        },
        workflowOnSubmitSuccess (submitValidationResult) {
            loggingService.log(this.isDebug, 'FileSearch', 'workflowOnSubmitSuccess')
            loggingService.logRaw(this.isDebug, submitValidationResult)
            //trigger media letter refresh if letter gen is triggered
            if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
            //reload wf status
            this.loadWorkflowStatus(this.fileSearchId)
        },
        handleWorklfowStatusChanged (newStatus, submitValidationResult) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'handleWorklfowStatusUpdated')
            this.currentWorkflowStatus = newStatus
        },
        loadPaymentReceipt (fileSearchId) {
            this.paymentReceipt = null
            paymentService.getTransactionReceipt(this.$http, paymentService.PaymentTypeEnum.FileSearch, fileSearchId).then(response => {
                this.paymentReceipt = response.data
            })
        },
        findRelatedFwrE106 (fileSearchId) {
            fileSearchService.findRelatedFwrE106(this.$http, fileSearchId).then(response => {
                this.hasFieldworkRequest = response.data.fieldworkRequestIdList.length > 0
                this.hasE106Compliance = response.data.e106complianceIdList.length > 0
            })
        },
        copyFwrPlss () {
            fileSearchService.copyFieldworkRequestPlssLocations(this.$http, this.fileSearch.fileSearchId).then(response => {
                this.loadPlssLocation(this.fileSearch.fileSearchId)
            })
        },
        copyE106Plss () {
            fileSearchService.copyE106CompliancePlssLocations(this.$http, this.fileSearch.fileSearchId).then(response => {
                this.loadPlssLocation(this.fileSearch.fileSearchId)
            })
        },
        handleMediaRefreshComplete () {
            this.loadPlssLocation(this.fileSearch.fileSearchId)
            this.mediaRefreshing = false
        },
        handleMediaRefreshStarted () {
            this.mediaRefreshing = true
        },
        getSiteZip () {
            this.zipFileAlertHidden = false
            fileSearchService.plssLocationList(this.$http, this.fileSearch.fileSearchId).then(response => {
                if (response.data && response.data.length > 0) {
                    //console.log('response data:', response.data)
                    var responseString = JSON.stringify(response.data)
                    gisZipService.gpSiteZip(responseString, this.shpoUserDto.gisToken.token).then(response2 => {
                        //console.log(response2)
                        this.zipFileAlertHidden = true
                    })
                }
            })
        }
    }
}

</script>

<style>
.textValue {
    vertical-align: middle;
    line-height: 35px;
}cd

.sectionCheckboxLabel {
    width: 20px;
    display: inline-block;
    margin-left: 15px;
}

.sectionRow {
    text-align: left;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// FileSearch.vue?7c8e1f96